import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../api/axiosClient';
import { API_BASE_URL, getBearerHeaders, getBearerJsonHeaders } from '../../api/constant';

const authGet = () => ({ headers: getBearerHeaders() });
const authJson = () => ({ headers: getBearerJsonHeaders() });

export const fetchFavorites = createAsyncThunk('favorites/fetchFavorites', async () => {
  const response = await axios.get(`${API_BASE_URL}/api/favorites`, authGet());
  return response.data;
});

export const addToFavorites = createAsyncThunk('favorites/addToFavorites', async (item) => {
  const response = await axios.post(`${API_BASE_URL}/api/favorites`, item, authJson());
  return response.data;
});

export const removeFromFavorites = createAsyncThunk('favorites/removeFromFavorites', async (id) => {
  await axios.delete(`${API_BASE_URL}/api/favorites/${id}`, authGet());
  return id;
});

export const clearFavorites = createAsyncThunk('favorites/clearFavorites', async () => {
  await axios.delete(`${API_BASE_URL}/api/favorites`, authGet());
  return [];
});

export const toggleFavorite = createAsyncThunk(
  'favorites/toggleFavorite',
  async (item, { getState }) => {
    const state = getState();
    const productKey = item.productId || item.id;
    const exists = state.favoritesState.favorites.some(
      (fav) => fav.productId === productKey || fav.productId === item.id
    );
    if (exists) {
      const fav = state.favoritesState.favorites.find(
        (f) => f.productId === productKey || f.productId === item.id
      );
      await axios.delete(`${API_BASE_URL}/api/favorites/${fav.id}`, authGet());
      return { ...item, removed: true, id: fav.id };
    } else {
      const productId = item.productId || item.id;
      const response = await axios.post(`${API_BASE_URL}/api/favorites`, { productId }, authJson());
      return response.data;
    }
  }
);

const initialState = {
  favorites: [],
  status: 'idle',
  error: null,
};

const favoritesSlice = createSlice({
  name: 'favoritesState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavorites.fulfilled, (state, action) => {
        state.favorites = action.payload;
        state.status = 'succeeded';
      })
      .addCase(addToFavorites.fulfilled, (state, action) => {
        state.favorites.push(action.payload);
      })
      .addCase(removeFromFavorites.fulfilled, (state, action) => {
        state.favorites = state.favorites.filter((item) => item.id !== action.payload);
      })
      .addCase(clearFavorites.fulfilled, (state, action) => {
        state.favorites = [];
      })
      .addCase(toggleFavorite.fulfilled, (state, action) => {
        if (action.payload.removed) {
          state.favorites = state.favorites.filter((item) => item.id !== action.payload.id);
        } else {
          state.favorites.push(action.payload);
        }
      });
  },
});

export default favoritesSlice.reducer;
export const selectFavorites = (state) => state.favoritesState.favorites;
